import { IInformationCalloutStyleProps, IInformationCalloutStyles } from "./InformationCallout.types";

export const getStyles = (
    props: IInformationCalloutStyleProps
): IInformationCalloutStyles => {

    const { theme, className } = props;

    return {
        root: [
            {
                // display: 'flex',
                // padding: 10,
                // backgroundColor: theme.palette.neutralLighter,
            },
            className, // Allow className overrides
        ],
        content: {
            // fontSize: theme.fonts.medium.fontSize,
        },
    };
};
